import { render, staticRenderFns } from "./VaccinationCertificateVerification.vue?vue&type=template&id=49e37936&scoped=true"
import script from "./VaccinationCertificateVerification.vue?vue&type=script&lang=js"
export * from "./VaccinationCertificateVerification.vue?vue&type=script&lang=js"
import style0 from "./VaccinationCertificateVerification.vue?vue&type=style&index=0&id=49e37936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e37936",
  null
  
)

export default component.exports